// import React from "react";
// import { GraduationCap, Globe, MessagesSquare, Award } from "lucide-react";
// import fashionimg from "../../../Assets/Images/FashionStudy.jpg";

// const CollabCourse = () => {
//   const data = [
//     {
//       icon: <GraduationCap size={48} className="md:size-16" />,
//       heading: "Industry Knowledge",
//       paragraph:
//         "Gain in-depth insights into the world of fashion, interior, and graphic design with guidance from industry experts and real-world case studies.",
//     },
//     {
//       icon: <Globe size={48} className="md:size-16" />,
//       heading: "Global Exposure",
//       paragraph:
//         "Experience global design trends and collaborate with international mentors through our unique cross-campus learning programs.",
//     },
//     {
//       icon: <MessagesSquare size={48} className="md:size-16" />,
//       heading: "Practical Learning",
//       paragraph:
//         "Work on live projects, design exhibitions, and portfolio-building activities that prepare you for real-world creative challenges.",
//     },
//     {
//       icon: <Award size={48} className="md:size-16" />,
//       heading: "Professional Certification",
//       paragraph:
//         "Earn an industry-recognized certificate from INSD that enhances your credibility and opens doors to global career opportunities.",
//     },
//   ];

//   return (
//     <div className="mt-8 lg:mt-20 mb-12 px-4 md:px-6 lg:px-10 w-full mx-auto">
//       <div className="flex flex-col lg:flex-row items-start justify-between gap-8 lg:gap-12">
//         <div className="w-full lg:w-1/2">
//           <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
//             What to Expect from a Collab Course
//           </h1>
//           <h3 className="text-base md:text-lg lg:text-xl font-normal leading-relaxed mt-4 lg:mt-6">
//             At{" "}
//             <span className="font-semibold">
//               INSD – International School of Design
//             </span>
//             , we blend creativity with innovation. Our collaborative courses
//             connect students with design professionals, brands, and creative
//             communities, ensuring a holistic learning journey.
//           </h3>
//           <div className="relative bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-lg mt-6 lg:mt-12 h-64 md:h-80 lg:h-96 overflow-hidden">
//             <div className="absolute inset-0 translate-x-1.5 -translate-y-1.5 lg:translate-x-4 lg:-translate-y-4 rounded-lg overflow-hidden shadow-lg">
//               <img
//                 src={fashionimg}
//                 alt="Fashion Design"
//                 className="w-full h-full object-cover rounded-lg"
//               />
//             </div>
//           </div>
//         </div>

//         <div className="w-full lg:w-1/2 flex flex-col gap-6">
//           <div className="order-2 lg:order-1 flex justify-start lg:justify-end">
//             <a className="group" href="/courses">
//               <button className="relative text-lg md:text-xl cursor-pointer px-8 py-4 md:px-10 md:py-5 items-center rounded-lg font-extrabold group-hover:bg-gradient-to-r from-[#DA3335] to-[#144982] group-hover:text-white overflow-hidden transition-all duration-300 bg-gradient-to-br from-[#DA3335] to-[#144982] text-white">
//                 <span className="block transition-transform duration-500 ease-in-out group-hover:-translate-y-16">
//                   Explore Courses
//                 </span>
//                 <span className="absolute inset-0 translate-y-full group-hover:translate-y-4 md:group-hover:translate-y-5 transition-transform duration-500 ease-in-out flex items-center justify-center">
//                   Explore Courses
//                 </span>
//               </button>
//             </a>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 order-1 lg:order-2 w-full">
//             {data.map((item, idx) => (
//               <div
//                 key={idx}
//                 className="border-2 px-5 py-6 md:px-7 md:py-8 rounded-lg shadow-md hover:bg-gradient-to-r from-[#DA3335] to-[#144982] hover:shadow-xl hover:text-white transition-all duration-300 h-full"
//               >
//                 <div>{item.icon}</div>
//                 <h1 className="mt-4 text-xl md:text-2xl font-extrabold leading-tight">
//                   {item.heading}
//                 </h1>
//                 <p className="mt-3 md:mt-4 text-sm md:text-base font-normal leading-relaxed">
//                   {item.paragraph}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CollabCourse;

import React, { useEffect } from "react";
import {
  GraduationCap,
  Globe,
  MessagesSquare,
  Award,
  Sparkles,
} from "lucide-react";
import fashionimg from "../../../Assets/Images/FashionStudy.jpg";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

const CollabCourse = () => {
  // useEffect(() => {
  //   AOS.init({ duration: 700, once: false });
  //   AOS.refresh();
  // }, []);
  const data = [
    {
      icon: <GraduationCap size={48} className="md:size-16" />,
      heading: "Industry Knowledge",
      paragraph:
        "Gain in-depth insights into the world of fashion, interior, and graphic design with guidance from industry experts and real-world case studies.",
    },
    {
      icon: <Globe size={48} className="md:size-16" />,
      heading: "Global Exposure",
      paragraph:
        "Experience global design trends and collaborate with international mentors through our unique cross-campus learning programs.",
    },
    {
      icon: <MessagesSquare size={48} className="md:size-16" />,
      heading: "Practical Learning",
      paragraph:
        "Work on live projects, design exhibitions, and portfolio-building activities that prepare you for real-world creative challenges.",
    },
    {
      icon: <Award size={48} className="md:size-16" />,
      heading: "Professional Certification",
      paragraph:
        "Earn an industry-recognized certificate from INSD that enhances your credibility and opens doors to global career opportunities.",
    },
  ];

  return (
    <div className="relative mt-8 mb-12 px-4 md:px-6 lg:px-10 w-full mx-auto overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-[#DA3335]/5 to-transparent rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tl from-[#144982]/5 to-transparent rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative flex flex-col lg:flex-row items-start justify-between gap-8 lg:gap-12">
        {/* Left Content Section */}
        <div
          // data-aos="fade-right"
          className="w-full lg:w-1/2 space-y-6 lg:space-y-8"
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#DA3335]/10 to-[#144982]/10 border border-[#DA3335]/20 rounded-full px-4 py-2 heading">
            <Sparkles size={16} className="text-[#DA3335]" />
            <span className="text-sm font-semibold text-gray-700">
              Premium Learning Experience
            </span>
          </div>

          {/* Main Heading */}
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-tight bg-gradient-to-r from-gray-900 via-[#DA3335] to-[#144982] bg-clip-text text-transparent heading">
              What to Expect from a Collab Course
            </h1>
            <div className="mt-4 w-20 h-1.5 bg-gradient-to-r from-[#DA3335] to-[#144982] rounded-full"></div>
          </div>

          {/* Description */}
          <h3 className="text-base md:text-lg lg:text-xl font-normal leading-relaxed text-gray-700 sub-heading">
            At{" "}
            <span className="font-bold bg-gradient-to-r from-[#DA3335] to-[#144982] bg-clip-text text-transparent">
              INSD – International School of Design
            </span>
            , we blend creativity with innovation. Our collaborative courses
            connect students with design professionals, brands, and creative
            communities, ensuring a holistic learning journey.
          </h3>

          {/* Enhanced Image Container */}
          <div className="relative group">
            {/* Gradient Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-2xl blur-sm group-hover:blur-md transition-all duration-500 h-full"></div>

            {/* Main Image Container */}
            <div className="relative bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-2xl p-1">
              <div className=" inset-0 translate-x-2 -translate-y-2 lg:translate-x-4 lg:-translate-y-4 rounded-2xl overflow-hidden shadow-2xl relative z-10">
                <img
                  src={fashionimg}
                  alt="Fashion Design"
                  className="w-full h-64 md:h-72 xl:h-96 object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
            </div>

            {/* Floating Stats Badge */}
            <div className="absolute bottom-2 left-6 bg-white rounded-xl shadow-2xl px-5 py-3 border border-gray-100 animate-float z-20">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-lg flex items-center justify-center">
                  <Award className="text-white" size={24} />
                </div>
                <div>
                  <p className="text-2xl font-extrabold text-gray-900 sub-heading">
                    100+
                  </p>
                  <p className="text-xs text-gray-600 sub-heading">
                    Success Stories
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content Section */}
        <div
          // data-aos="fade-left"
          className="w-full xl:w-1/2 flex flex-col gap-6 xl:gap-8"
        >
          {/* Feature Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 w-full">
            {data.map((item, idx) => (
              <motion.div
                key={idx}
                className="group relative border-2 border-gray-200 bg-white px-5 py-6 md:px-7 md:py-8 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 h-full overflow-hidden cursor-pointer"
              >
                {/* Hover Background Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#DA3335] to-[#144982] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                {/* Card Content */}
                <div className="relative z-10">
                  {/* Icon Container */}
                  <div className="inline-flex p-3 bg-gradient-to-br from-[#DA3335]/10 to-[#144982]/10 rounded-xl group-hover:bg-white/20 transition-colors duration-500">
                    <div className="text-[#DA3335] group-hover:text-white transition-colors duration-500">
                      {item.icon}
                    </div>
                  </div>

                  {/* Heading */}
                  <h1 className="mt-4 text-xl md:text-2xl font-extrabold leading-tight text-gray-900 group-hover:text-white transition-colors duration-500 heading">
                    {item.heading}
                  </h1>

                  {/* Divider */}
                  <div className="mt-3 w-12 h-1 bg-gradient-to-r from-[#DA3335] to-[#144982] rounded-full group-hover:w-full group-hover:bg-white transition-all duration-500"></div>

                  {/* Description */}
                  <p className="mt-3 md:mt-4 text-sm md:text-base font-normal leading-relaxed text-gray-600 group-hover:text-white/90 transition-colors duration-500 sub-heading tracking-wide">
                    {item.paragraph}
                  </p>
                </div>

                {/* Decorative Corner Element */}
                <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default CollabCourse;
